import axios from 'axios'
import {config} from '../server/config';
import { minifiedScheduleQuerySHA,minifiedScheduleQuery } from './Graphql/Queries/scheduleGameQuery';
import logger from './logger';

export function fetchScheduleGameData(variables,url) {
    try{
       const requestUrl = url+'?extensions={"persistedQuery":{"version":1,"sha256Hash":'+JSON.stringify(minifiedScheduleQuerySHA)+'}}&variables='+JSON.stringify(variables)
       // `no-store` prevents stale schedule data from the browser disk cache; the
       // shared CDN cache still serves this GET.
       return fetch(requestUrl, { cache: 'no-store' })
        .then((response) => {
           if (!response.ok) {
              throw new Error(`HTTP ${response.status} ${response.statusText}`);
           }
           return response.json();
        })
        .then((res) => {
           //if persisted query not found 
           if(res.errors) {
              if(res?.errors?.[0]?.message === "PersistedQueryNotFound") {
                 return cacheScheduleGameData(variables,url) 
              }
           }
           else{
              let data = res?.data
              return data
           }
        })
        .catch(err => {
           logger(`Schedule fetch error: ${err}`, "error")
        })
     }
     catch(err){
      logger(`Schedule fetch error: ${err}`, "error")
     }
  }

  export function cacheScheduleGameData (variable,url) {
    let endpoint = `${config.cachedAPI || config.apiBaseUrl}/graphql`
      let finalPayload = {
        "query": minifiedScheduleQuery,
        "variables": variable,
        "extensions": {
            "persistedQuery": {
                "version": 1,
                "sha256Hash": minifiedScheduleQuerySHA
            }
        }
      }
      try{
        return axios.post(endpoint, finalPayload)
            .then(response => {  
               return fetchScheduleGameData(variable,url)
            })
            .catch(error => {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    logger(error.response.data, "error");
                  } else {
                    // Something happened in setting up the request that triggered an Error
                    logger(error.message, "error");
                  }
            });
     }
     catch(err){
        logger(`Cache schedule fetch error: ${err}`, "error")
     }
  }